import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { useRecoilState } from "recoil";
import { assignableUsersState } from "./atoms";

export default function useAssignableUsers () {
    const [users, setUsers] = useRecoilState(assignableUsersState);
    
    useEffect(() => {   
        const getAssignableUsers = async () => {
            try {
                const res = await apiClient.get(`/support-ticket/assignable-users`);
                setUsers(res.data);
            } catch (err) {
                alert(err);
            }
        }
        if (!users.length) {
            getAssignableUsers();
        }
    }, []);

    return users;
}